import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { JiraTicket } from '../../types';

interface JiraTicketListProps {
  tickets: JiraTicket[];
}

function JiraTicketList({ tickets }: JiraTicketListProps) {
  return (
    <>
      <p>List of Jira tickets created:</p>
      <ListGroup activeKey="" data-cy="jira-ticket-list">
        {tickets.map(t => (
          <ListGroup.Item
            key={t.id}
            action
            href={t.jira_url}
            target="_blank"
            variant="primary"
          >
            {t.key}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </>
  );
}

export default JiraTicketList;
